import { useState, useEffect } from "react";
import { TextField, Button, Card, CardContent, Typography } from "@mui/material";

export default function LineMessageSender() {
  const [apiKey, setApiKey] = useState("");
  const [recipientId, setRecipientId] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const [apiUrl, setApiUrl] = useState("");

  useEffect(() => {
    setApiKey(localStorage.getItem("lineApiKey") || "");
    setRecipientId(localStorage.getItem("lineRecipientId") || "");
    setApiUrl(localStorage.getItem("lineApiUrl") || "");
  }, []);

  const saveToLocalStorage = () => {
    localStorage.setItem("lineApiKey", apiKey);
    localStorage.setItem("lineRecipientId", recipientId);
    localStorage.setItem("lineApiUrl", apiUrl);
  };

  const sendMessage = async () => {
    if (!apiKey || !recipientId || !apiUrl || !message) {
      setStatus("All fields are required.");
      return;
    }

    setStatus("Sending...");
    saveToLocalStorage();
    
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          apiKey,
          recipientId,
          message,
        }),
      });

      if (response.ok) {
        setStatus("Message sent!");
      } else {
        const errorData = await response.json().catch(() => ({ error: "Invalid response format" }));
        setStatus(`Failed to send message: ${errorData.error || "Unknown error"}`);
      }
    } catch (error) {
      setStatus(`Error: ${error.message}`);
    }
  };

  return (
    <Card sx={{ p: 4, maxWidth: 500, mx: "auto" }}>
      <CardContent>
        <Typography variant="h5" component="h2" gutterBottom>
          LINE Message Sender
        </Typography>
        <TextField
          label="LINE API Key"
          variant="outlined"
          fullWidth
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          margin="normal"
        />
        <TextField
          label="Recipient ID"
          variant="outlined"
          fullWidth
          value={recipientId}
          onChange={(e) => setRecipientId(e.target.value)}
          margin="normal"
        />
        <TextField
          label="Azure Functions URL"
          variant="outlined"
          fullWidth
          value={apiUrl}
          onChange={(e) => setApiUrl(e.target.value)}
          margin="normal"
        />
        <TextField
          label="Message"
          variant="outlined"
          fullWidth
          multiline
          rows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          margin="normal"
        />
        <Button variant="contained" color="primary" fullWidth onClick={sendMessage}>
          Send
        </Button>
        <Typography variant="body2" align="center" sx={{ mt: 2 }}>
          {status}
        </Typography>
      </CardContent>
    </Card>
  );
}
